import { convertToPoperdateTime } from "../../../../../utils/constants/functions";
import DeleteFood from "./DeleteFood";
import VerifyAction from "./VerifyAction";
import VerifyStatus from "./VerifyStatus";
import { Button } from "@mui/material";


export const FoodTableColumn = (showFoodTimeStamp, foodFinePermission, setFoodFineEmployeeId, setRowData) => [
    {
      field: "serialNumber",
      headerName: "slNo",
      width:80
    },
    {
      field: "name",
      headerName: "Name",
      width: 230,
    },
    {
      field: "designation",
      headerName: "Designation / Role",
      width: 250,
    },
    {
      field: "department",
      headerName: "Department",
      width: 250,
    },
    {
      field: "office_name",
      headerName: "Office",
      width: 150,
    },
    {
      field: "tbl_food_slot",
      headerName: "Slot",
      width: 200,
    },
    {
      field: "food_category_name",
      headerName: "Food Type",
      width: 100,
    },
    ...(showFoodTimeStamp?[{
      field:"food_timestamp",
      headerName:"Timestamp",
      width:180,
      renderCell:(params)=>{
      const foodNeededDate=params.row.food_date
      const splitedDateFromFoodTimestamp=params.row.food_timestamp.split(' ')[0]
      const color=foodNeededDate!==splitedDateFromFoodTimestamp?'green':'red'
       const value= convertToPoperdateTime(params.row.food_timestamp)
       return <span style={{color}}>{value}</span>
      }
    }]:[]),
    {
      field: "food_list_verification_status",
      headerName: "Verfication Status",
      width: 180,
      renderCell:(params)=><VerifyStatus status={params.row.food_list_verification_status}/>
    },
    {
      field: "Verify",
      headerName: "Verfy Action",
      width: 150,
      renderCell:(params)=><VerifyAction id={params.row.food_id} status={params.row.food_list_verification_status}  date={params.row.food_date} shift={params.row.food_shift_id}/>
    },
    {
      field: "Delete",
      headerName: "Delete",
      width: 150,
      renderCell:(params)=><DeleteFood date={params.row.food_date} shift={params.row.food_shift_id} id={params.row.food_id}/>
    },
    {
      field: "FoodFine",
      headerName: "Food Fine Status",
      width: 150,
      valueGetter: (params) => (params.row.food_availability > 0 ? "Currently Blocked" : "Currently Available"),
    },
    ...(foodFinePermission
      ? [
          {
            field: "FoodFineAction",
            headerName: "Food Action",
            width: 100,
            renderCell: (params) => {
              return (
                <Button
                  variant="outlined"
                  color={params.row.food_availability > 0 ? "success" : "error"}
                  onClick={() => {
                    setFoodFineEmployeeId(params.row.food_user_id);
                    setRowData(params.row);
                  }}
                >
                  {params.row.food_availability > 0 ? "Unblock" : "Block"}
                </Button>
              );
            },
          },
        ]
      : []),
  ];
  